import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';

import Dialog from '@material-ui/core/Dialog';
import DialogButton from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import ProgressCircle from "./components/ProgressCircle"
import ToolTip from '../atoms/ToolTip';
import { Button } from '../atoms/button';
import BackComponent from '../atoms/backComponent';

import { CardBox } from './../atoms/card';
import { ListItem } from '../atoms/listitem';
import { ListCard } from '../atoms/listCard';
import variables from '../atoms/variables.json';

import HomeSetup from './../../../../assets/svgIcons/OpenFlo/DepositProtect.svg';
import Movein from './../../../../assets/svgIcons/OpenFlo/MoveIn.svg';
import Aggrement from './../../../../assets/svgIcons/OpenFlo/Agreement.svg';
import ID_ICON from './../../../../assets/svgIcons/OpenFlo/ID&Reference.svg';
import HOLDING_ICON from './../../../../assets/svgIcons/OpenFlo/HoldingDeposit.svg';
import RENTAL_ICON from './../../../../assets/svgIcons/OpenFlo/RentalOffer.svg';
import DOC_ICON from './../../../../assets/svgIcons/OpenFlo/Documentation.svg';
import TEANANT_ICON from './../../../../assets/svgIcons/OpenFlo/Tenant.svg';
import MAINTANANCE_ICON from './../../../../assets/svgIcons/OpenFlo/maintainance.svg';

import { Card, CardHeader, CardContent, Grid, Typography, Alert, Box, Chip, Checkbox, FormControlLabel } from '@mui/material';

import { CardWrapper, SubHeading, TlyfeButtonWrapper, TouchableArea } from './style';
import drawerHoc from '../../../../components/drawerHOC/DrawerHOC';
import { navigate } from '../../../../navigation/RootNavigation';
import { tenantActions } from '../../redux/tenant.actions';
import HorizontalTabSlider from './components/HorizontalTabSlider';

const TeanantOnboarding = (props) => {
  const dispatch = useDispatch();
  const globalState = useSelector((state) => state?.tenant);

  const [flowId, setFlowId] = React.useState(null);
  const [flowIdInfo, setFlowIdInfo] = React.useState(2);

  const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);
  const [showWarningDialog, setShowWarningDialog] = React.useState(false);
console.log("flowId",flowId)
  const closeDialog = () => {
    setShowConfirmDialog(false);
  };

  const closeWarningDialog = () => {
    setShowWarningDialog(false);
  };

  const addFlowToProperty = () => {
    // dispatch(tenantActions.addFlowToProperty(globalState?.flowIdInfo?.openflow_id));
    closeDialog();
  };

  const openDialog = () => {
    let allCompleted = ListArray.filter((item) => Boolean(item.buttonStatus)).every(function (item) {
      return flowIdInfo[item.buttonStatus] == 1;
    });
    if (allCompleted) {
      setShowConfirmDialog(true);
    } else {
      setShowWarningDialog(true);
    }
  };

  useEffect(() => {
    console.log("props",props)
    if (props?.route?.params) {
      if (props?.route?.params?.id && props?.route?.params?.id != 'new') {
        dispatch(tenantActions.getFlowInfo(props?.route?.params?.id));
      } else {
        dispatch(tenantActions.cleanGetFlowInfo());
      }
    }
  }, []);

  useEffect(() => {
    if (globalState?.flowIdInfo?.openflow_id) {
      setFlowId(globalState?.flowIdInfo?.openflow_id);
      setFlowIdInfo(globalState?.flowIdInfo);
    }
  }, [globalState]);

  const ListArray = [
    {
      title: 'Tenant',
      buttonStatus: 'tenancy_status',
      routeKey: 'TenantDetails',
      desc: `Begin the tenant moving in process by "pairing" your Applicant Tenant(s) to your property.`,
      icon: TEANANT_ICON,
    },
    {
      title: 'Landlord & Property Documentation',
      buttonStatus: 'doc_status',
      routeKey: 'PropertyDocumentation',
      desc: 'Please ensure all details are correct so that all documentation, certificates and compliance requirements are correct.',
      icon: DOC_ICON,
    },
    {
      title: globalState?.flowIdInfo.is_renewed?'Renewal Offer': 'Rental Offer',
      buttonStatus: 'rental_offer_status',
      routeKey: 'RentalOffers',
      desc: 'The following information contains the details of the offer agreed on the proposed property, subject to contract. ',
      icon: RENTAL_ICON,
    },
    {
      title: 'Holding Deposit',
      buttonStatus: 'holding_deposit_status',
      routeKey: 'HoldingDeposit',
      desc: 'Paying a Holding Deposit indicates the Applicant Tenant(s) intention to accept the terms of the rental offer, subject to contract. ',
      icon: HOLDING_ICON,
    },
    {
      title: 'Tenant ID & Reference ',
      buttonStatus: 'verification_status',
      routeKey: 'IdAndReference',
      desc: "Verify the Applicant Tenant(s) ID, fulfil 'Right to Rent' obligations and start the Reference procedure.",
      icon: ID_ICON,
    },
    {
      title: 'Tenancy Agreement',
      buttonStatus: 'landlord_status',
      routeKey: 'TenancyAgreement',
      desc: 'Digitally create, check or amend your tenancy Agreement and send to all parties.',
      icon: Aggrement,
    },
    {
      title:  globalState?.flowIdInfo.is_renewed? 'Renewal Payments': 'Move in',
      buttonStatus: 'move_in_status',
      routeKey: 'MoveIn',
      desc: `A breakdown of all "Moving in" Monies, plus the prescribed information and requirements of the Deposit. `,
      icon: Movein,
    },

    {
      title:  globalState?.flowIdInfo.is_renewed? 'Deposit Protection & Home Concierge' : 'Deposit Protect & Home Setup',
      buttonStatus: 'property_status',
      routeKey: 'DepositProtectHomeSetup',
      desc: globalState?.flowIdInfo.is_renewed? 'Re-protect the deposit and review all utility providers.' : 'Protect the deposit and arrange all utility and home set-up connections for your Tenants',
      icon: HomeSetup,
    },
    {
      title:   'Maintenance',
      routeKey: 'Maintenance',
      desc:  'Maintenance issues',
      icon: MAINTANANCE_ICON,
    },
    
  ];
  const getLeadTenant = () => {
    let tenant = flowIdInfo.tenants;
    var leadTenant = tenant.filter(function (e) {
      return e.is_lead == true;
    });
    return leadTenant[0]?.app_user?.user;
  };

  const getChipInfo = (statusKey) => {
    const val = flowIdInfo ? flowIdInfo[statusKey] : 0;
    if (val == 1) {
      return {
        label: 'Completed',
        bgcolor: '#28c76f',
        color: '#ffffff',
      };
    } else if (val == 4) {
      return {
        label: 'In Progress',
        bgcolor: '#7367f0',
        color: '#ffffff',
      };
    } else if (val == 5) {
      return {
        label: 'Action Required',
        bgcolor: '#ea5455',
        color: '#ffffff',
      };
    }
    return {
      label: 'Not Started',
      bgcolor: '#a8aaae',
      color: '#ffffff',
    };
  };

  const handleToggleComplete = (statusKey, isCurrentComplete) => {
    const nextVal = !isCurrentComplete;
    const endpoint = nextVal
      ? `/openflow/${statusKey}/mark-as-complete?flow_id=${flowId}`
      : `/openflow/${statusKey}/mark-as-incomplete?flow_id=${flowId}`;
    dispatch(tenantActions.toggleComplete(endpoint, flowId));
  };

  const renderCardIcon = (icon) => {
    if (!icon) return null;
    if (typeof icon === 'string') {
      return <img src={icon} style={{ width: 24, height: 24, objectFit: 'contain' }} alt="" />;
    }
    if (typeof icon === 'function') {
      const IconComp = icon;
      return <IconComp width={24} height={24} />;
    }
    if (icon.default && typeof icon.default === 'string') {
      return <img src={icon.default} style={{ width: 24, height: 24, objectFit: 'contain' }} alt="" />;
    }
    if (icon.uri && typeof icon.uri === 'string') {
      return <img src={icon.uri} style={{ width: 24, height: 24, objectFit: 'contain' }} alt="" />;
    }
    return <img src={icon} style={{ width: 24, height: 24, objectFit: 'contain' }} alt="" />;
  };

  //       this.props.history.push("/dashboard/partnership");
  return (
    <>
      <div>
        <Dialog
          open={showConfirmDialog}
          onClose={closeDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title"> Move to Property? </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to complete this onboard?
            </DialogContentText>
            <DialogContentText id="alert-dialog-description">
              If you select "YES", the flow will be moved to the "completed onboards" section
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <DialogButton onClick={addFlowToProperty} color="primary" autoFocus>
              Yes
            </DialogButton>
            <DialogButton onClick={closeDialog} color="primary">
              No
            </DialogButton>
          </DialogActions>
        </Dialog>
      </div>

      <div>
        <Dialog
          open={showWarningDialog}
          onClose={closeWarningDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title"> Incomplete flow </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            Please note: You must tick complete on all of the sections of the flo to complete the tenant progression.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <DialogButton onClick={closeWarningDialog} color="primary">
              Ok
            </DialogButton>
          </DialogActions>
        </Dialog>
      </div>
<ProgressCircle props={props} />
      {flowIdInfo ? (
        <Card
          elevation={0}
          sx={{
            p: { xs: 2.5, md: 4 },
            m: { xs: 1.5, md: 3 },
            borderRadius: 2.5,
            bgcolor: '#ffffff',
            boxShadow: '0 2px 12px 0 rgba(76, 78, 100, 0.08)',
            border: '1px solid #eef0f3',
          }}
        >
          <CardHeader
            sx={{ p: 0, mb: 3 }}
            title={
              <Typography
                variant="h5"
                sx={{
                  color: '#2e4374',
                  fontWeight: 700,
                  fontSize: '1.25rem',
                }}
              >
                tlyfePro Home
              </Typography>
            }
          />
          <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  sx={{
                    mb: 3,
                    borderRadius: 2,
                    bgcolor: '#e5f3fd',
                    color: '#014361',
                    border: '1px solid #c9e6fb',
                    fontSize: '0.875rem',
                    '& .MuiAlert-icon': {
                      color: '#0288d1',
                      fontSize: '1.4rem',
                      alignSelf: 'center',
                    },
                  }}
                >
                  tlyfePRO is the tenant moving in system that interacts with your tenant via their own tlyfe app. You can go through the process steps, in any order you wish. The system will guide you through in a compliant way.
                </Alert>
              </Grid>
              {ListArray.map((data, index) => {
                const isCompleted = data.buttonStatus && flowIdInfo && flowIdInfo[data.buttonStatus] == 1;
                const chipInfo = data.buttonStatus ? getChipInfo(data.buttonStatus) : null;
                return (
                  <Grid item xs={12} sm={6} key={index}>
                    <Card
                      elevation={0}
                      sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        borderRadius: 2.5,
                        bgcolor: '#ffffff',
                        border: '1px solid #eef0f3',
                        boxShadow: '0 2px 8px 0 rgba(76, 78, 100, 0.05)',
                        transition: 'transform 0.18s ease, box-shadow 0.18s ease',
                        '&:hover': {
                          boxShadow: '0 6px 20px 0 rgba(76, 78, 100, 0.11)',
                          transform: 'translateY(-2px)',
                        },
                      }}
                    >
                      <CardHeader
                        sx={{
                          p: 2.5,
                          pb: 1.5,
                          alignItems: 'center',
                          '& .MuiCardHeader-content': {
                            overflow: 'hidden',
                          },
                          '& .MuiCardHeader-action': {
                            m: 0,
                            alignSelf: 'center',
                          },
                        }}
                        avatar={
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mr: -0.5 }}>
                            {renderCardIcon(data.icon)}
                          </Box>
                        }
                        title={
                          <Typography
                            variant="subtitle1"
                            onClick={() => {
                              if (data?.routeKey) {
                                navigate(data?.routeKey, { id: flowId });
                              }
                            }}
                            sx={{
                              color: '#2e4374',
                              fontWeight: 600,
                              fontSize: '1rem',
                              cursor: 'pointer',
                              transition: 'color 0.15s ease',
                              '&:hover': {
                                color: '#7367f0',
                              },
                            }}
                          >
                            {data.title}
                          </Typography>
                        }
                        action={
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              flexDirection: 'row',
                              gap: 1.2,
                              ml: 1,
                            }}
                          >
                            {data.buttonStatus ? (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={Boolean(isCompleted)}
                                    onChange={() => handleToggleComplete(data.buttonStatus, isCompleted)}
                                    size="small"
                                    sx={{
                                      p: 0.5,
                                      color: '#b4b7bd',
                                      '&.Mui-checked': {
                                        color: '#7367f0',
                                      },
                                    }}
                                  />
                                }
                                label="Mark As Complete"
                                sx={{
                                  m: 0,
                                  '& .MuiFormControlLabel-label': {
                                    fontSize: '0.8125rem',
                                    color: '#6e6b7b',
                                    fontWeight: 500,
                                    userSelect: 'none',
                                    whiteSpace: 'nowrap',
                                  },
                                }}
                              />
                            ) : null}
                            <Chip
                              label={chipInfo ? chipInfo.label : 'View'}
                              size="small"
                              onClick={() => {
                                if (data?.routeKey) {
                                  navigate(data?.routeKey, { id: flowId });
                                }
                              }}
                              sx={{
                                bgcolor: chipInfo ? chipInfo.bgcolor : '#7367f0',
                                color: chipInfo ? chipInfo.color : '#ffffff',
                                fontWeight: 600,
                                fontSize: '0.75rem',
                                height: 24,
                                px: 0.5,
                                borderRadius: '16px',
                                cursor: 'pointer',
                                boxShadow: 'none',
                                '&:hover': {
                                  opacity: 0.9,
                                },
                              }}
                            />
                          </Box>
                        }
                      />
                      <CardContent sx={{ px: 2.5, pt: 0, pb: 2.5, '&:last-child': { pb: 2.5 } }}>
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#6e6b7b',
                            fontSize: '0.85rem',
                            lineHeight: 1.5,
                          }}
                        >
                          {data.desc}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </CardContent>
        </Card>
      ) : null}
    </>
  );
};
export default drawerHoc({
  Component: TeanantOnboarding,
  showBackButton: true,
  backNavigation:"CurrentOnboards" 
});
